module.exports = __webpack_public_path__ + "img/SKMJ_cap.7363a4e1.jpg";